module.exports = "/_next/static/images/CreateOneCustomerConversation@2x-4aba29e24db8d6a83985698116b6f846.webp";